import script from "./releasesForm.vue?vue&type=script&setup=true&lang=js"
export * from "./releasesForm.vue?vue&type=script&setup=true&lang=js"

import "./releasesForm.vue?vue&type=style&index=0&id=40251158&lang=css"

const __exports__ = script;

export default __exports__